import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
@Injectable({
    providedIn: 'root'
  })
export class RefCodeService {

    constructor(private _HttpClient:HttpClient) { }
    GetRefCodes():Observable<any>{
        return this._HttpClient.get(`${environment.Server_URL}/ReferenceCode/GetAllReferenceCodes`);
      }
}
